import {
  useCreateData,
  useDeleteTableDataPlan,
  usePutData,
} from "./tableHooks";
import * as messages from "../../../utils/constants";

/**
 * @param {*} date obj
 * @returns string ex) "2025-01-01 08:00:00"
 */
const workTimeCalculateFormat = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");
  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
  );
};

export const useTableOperations = (
  updateStatus,
  openSnackbar,
  group_code,
  project_code
) => {
  const createOrderMutation = useCreateData(
    updateStatus,
    "/api/order/postOrder",
    openSnackbar
  );
  const deleteOrderMutation = useDeleteTableDataPlan(
    updateStatus,
    "/api/order/deleteOrder",
    openSnackbar
  );
  const updateOrderMutation = usePutData(
    updateStatus,
    "/api/order/putOrder",
    openSnackbar
  );
  const doSchedulingMutation = useCreateData(
    false,
    "/api/tpc/generate",
    openSnackbar,
    true
  );
  const handleCreateOrder = async ({ values, table }, setUpdateStatus) => {
    if (!createFormValidation(values)) {
      openSnackbar(messages.notAllowedEmpty, "info");
      return;
    }
    if (values.order_name.length > 15) {
      openSnackbar("주문명은 15자 이내로 입력해 주세요.", "warning");
      return;
    }
    const copiedObj = {
      ...values,
      start_date: workTimeCalculateFormat(new Date(values.start_date)),
      due_date: workTimeCalculateFormat(new Date(values.due_date)),
      group_code,
      project_code,
    };
    createOrderMutation.mutate(copiedObj);
  };
  const handleDeleteSelected = (table, setUpdateStatus) => {
    const selectedRows = table.getSelectedRowModel().rows;
    const selectedOrderIds = selectedRows.map((row) => row.original.order_id);
    const deleteObj = {
      data: selectedOrderIds,
      group_code,
      project_code,
    };
    if (selectedOrderIds.length === 0) {
      openSnackbar(messages.deleteSelect, "error");
      return;
    }
    if (window.confirm(messages.deleteConfirm)) {
      deleteOrderMutation.mutate(deleteObj);
    }
  };
  const handleUpdateOrder = async ({ values, table }, setUpdateStatus) => {
    const copiedObj = {
      ...values,
      start_date: workTimeCalculateFormat(new Date(values.start_date)),
      due_date: workTimeCalculateFormat(new Date(values.due_date)),
      group_code,
      project_code,
    };
    console.log("handleUpdateOrder calling");
    updateOrderMutation.mutate(copiedObj);
  };
  return {
    createOrderMutation,
    deleteOrderMutation,
    updateOrderMutation,
    doSchedulingMutation,
    handleCreateOrder,
    handleDeleteSelected,
    handleUpdateOrder,
  };
};

const createFormValidation = (values) => {
  return (
    !!values.item_id &&
    !!values.qty &&
    !!values.order_name &&
    !!values.start_date
  );
};
